import { commentWall } from "@/mocks/homeData";

export default function CommentWall() {
  return (
    <section id="comments" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex items-center gap-3">
          <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-chat-voice-line text-lg leading-none" />
          </span>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Comment Wall / 热评走廊</p>
            <h2 className="mt-1 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              评论区先吵起来了
            </h2>
          </div>
        </div>
        <p className="mt-3 max-w-2xl text-sm leading-6 text-foreground-600">
          每条档案的评论区实时氛围速览。想看带完整楼中楼的原评，点卡片即可回到对应人物主页。
        </p>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {commentWall.map((c, i) => (
            <article
              key={i}
              className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-background-300"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className="grid h-9 w-9 place-items-center rounded-full bg-secondary-200 text-secondary-900 text-sm font-bold">
                    {c.initials}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{c.name}</p>
                    <p className="text-xs text-foreground-500">{c.role}</p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-fire-fill text-sm leading-none" />
                  {c.likes}
                </span>
              </div>
              <p className="mt-4 flex-1 text-[15px] leading-7 text-foreground-800">{c.text}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-chat-3-line text-sm leading-none" />
                  {c.replies} 回复
                </span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-double-quotes-l text-sm leading-none" />
                  来自 {c.source}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}